import { Component, OnInit, ViewChild } from '@angular/core';
import { UtilService } from './shared/_services/util.service';
import { AuthService } from './auth/auth.service';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';
  enableRoute: boolean = false;
  loading: boolean = false;
  modalRef: any;
  configData;
  @ViewChild('autocontent') modelContent: any;
  config = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
    class: "autoLoginModal"
  };
  authMessage: any;
  constructor(
    private router: Router,
    private modalService: BsModalService,
    private authService: AuthService,
    private utilService: UtilService
  ) {
    
  }

  ok() {
    this.modalRef.hide();
    this.router.navigate(['/login']);
  }
  
  autoLogin(token, kitId,customerType?, type?) {

    this.authService.loginWithSession(token).subscribe(res => {
      //console.log('============== login Response =======', res);
      localStorage.setItem('autoLoginUserObj', JSON.stringify(res.responseObj));
      // this.globalService.setLogInEvent(res);
      this.loading = false;
      this.enableRoute = true;
      if(type == 'kit') {
        this.router.navigate(['kitsDashboard', 'kitPriceList', kitId]);
      } else if(type == 'customer') {
        this.router.navigate(['customersDashboard', 'customersPriceList', kitId, customerType]);
      } else if(type == 'releaseOnhold') {
        this.router.navigate(['releaseOnhold',kitId]);
      } else if(type == 'creditCardDetails') {
        this.router.navigate(['creditCardDetails',kitId]);
      }

    }, err => {
      this.loading = false;
      this.enableRoute = true;
      this.authMessage = err && err.message ? err.message : 'Invalid Session';
      this.modalRef = this.modalService.show(this.modelContent, this.config);
      //console.log('Error while trying to login with token: ', err);
      // this.globalService.setLogInEvent(err);
    })
  }

  ngOnInit(): void {
   /* console.log("ngOnInit"+ 1);
    let sessionId = this.utilService.getQueryStringValue('sessionId');
    let kitId = this.utilService.getQueryStringValue('kitId');
    let customerId = this.utilService.getQueryStringValue('customerId');
    let customerType = this.utilService.getQueryStringValue('entityType');
    let pageName = this.utilService.getQueryStringValue('page');
    let authToken = this.authService.getToken;
    if (sessionId && kitId) {
      this.loading = true;
      this.authService.logout();
      this.autoLogin(sessionId, kitId, null, 'kit');
    } else if(sessionId && customerId && customerType) {
      this.loading = true;
      this.authService.logout();
      this.autoLogin(sessionId, customerId, customerType, 'customer');
    } else if(sessionId && customerId && pageName == 'releaseOnHoldTransaction' ) {
    this.loading = true;
    this.authService.logout();
    this.autoLogin(sessionId, customerId, null, 'releaseOnhold');
  } else if(sessionId && customerId && pageName == 'creditCardDetails' ) {
    this.loading = true;
    this.authService.logout();
    this.autoLogin(sessionId, customerId, null, 'creditCardDetails');
  } else {
      this.enableRoute = true;
  }*/
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts